var styles = {
  "Header": "Polaris-Modal-Header",
  "titleHidden": "Polaris-Modal-Header--titleHidden",
  "Title": "Polaris-Modal-Header__Title"
};

export { styles as default };
